import type { SpinnerStyleConfig } from './types';

const BASE_STYLE = {
  borderColor: 'feature.placeholder',
  width: 'var(--spinner-size)',
  height: 'var(--spinner-size)',
  flexShrink: 0,
};

const SIZES = {
  sm: {
    '--spinner-size': '1rem',
  },
  md: {
    '--spinner-size': '1.5rem',
  },
  lg: {
    '--spinner-size': '2.5rem',
  },
  xl: {
    '--spinner-size': '3.5rem',
  },
};

const DEFAULT_PROPS = {
  size: 'md',
} as const;

export const SPINNER_STYLE_CONFIG: SpinnerStyleConfig = {
  baseStyle: BASE_STYLE,
  sizes: SIZES,
  defaultProps: DEFAULT_PROPS,
};
